import React, { Component } from 'react'
import Counsellorsidebar from './sidebar/sidebar'

class ethics extends Component {
    render() {
        return (
            <div>
                <Counsellorsidebar head="Ethics" />
                <div className="container" style={{ marginTop: "60px" }}>
                    <div className="row">
                        <div  className="col-12 col-md-10">

                    
                        <ul>
                            <li>
                            Guiding/triaging patients towards psychologists, psychotherapists, or psychiatrists according to their need
                            </li>
                            <li>Carrying out basic profiling of the client with regards to their condition</li>
                            <li>Regular follow-ups on a fortnightly/monthly basis (as and when required)</li>
                            <li>Constant monitoring and tracking of client’s progress</li>
                            <li>
                            Providing necessary psychoeducation pertaining to client’s problems
                            </li>
                            <li>Providing a working impression for every user upon 5-7 interactions using appropriate DSM/ICD guidelines</li>
                            <li>
                            Kickstarting basic therapy before taking it offline
                            </li>
                            <li>Understanding the interface fully well to prevent breaches of privacy or confidentiality</li>
                            <li>Attempting to identify problems in other areas of functionality (occupations, relationships etc)</li>
                            <li>Following the ethical code of conduct in spirit</li>
                            <li>Ensuring needed emotional support is provided</li>
                            <li>Recommending a treatment plan thoroughly in tandem with patient’s condition without any sense of bias</li>
                            <li>Realizing one’s limitations pertaining to the actual treatment plan</li>
                            <li>Reporting in cases of spam/dishonesty of intent of a user</li>
                        </ul>
                        </div>
                    </div>

                </div>
            </div>
        )
    }
}

export default ethics
